import { Component, OnInit } from "@angular/core";
import { TraceClassDecorator } from "@sentry/angular";
import { ProviderStateService } from "src/app/services/provider-state.service";
import { UtilitiesService } from "src/app/utilities/utilities.service";

@Component({
    selector: "app-not-found-page",
    templateUrl: "./not-found-page.component.html",
    styleUrls: ["./not-found-page.component.css"],
})
@TraceClassDecorator()
export class NotFoundPageComponent implements OnInit {
    slug: string = "";
    logo_url: string = "";
    constructor(
        private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }


    ngOnInit(): void { 
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }
}
